var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"value-link d-flex justify-content-between",class:{
  selected: _vm.filter_item.selected,
  subSelected: _vm.filter_item.fl_isParentCategory && !_vm.filter_item.selected
},attrs:{"href":_vm.filter_item.fl_url}},[_vm._v(" "+_vm._s(_vm.filter_item.value)+" "),(_vm.filter_item.frequency > 0)?_c('span',{staticClass:"frequency"},[_vm._v("("+_vm._s(_vm.filter_item.frequency)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }